import React from 'react';
import PremiumCreditsPurchaseModal from '../premium_credits/PremiumCreditsPurchaseModal';
import './callout_banner.scss';
import { Tooltip } from '@material-ui/core';
import HelpCircleOutlineIcon from 'mdi-react/HelpCircleOutlineIcon';
import IconButton from '@material-ui/core/IconButton';
import { connect } from 'react-redux';
import { _hasPermission } from '../../helpers/access';

class CalloutBanner extends React.PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			collapsed: false,
			dismissed: false
		};

		this._dismiss = this._dismiss.bind(this);
		this._expand = this._expand.bind(this);
		this._collapse = this._collapse.bind(this);

		this.openPremiumCredits = this.openPremiumCredits.bind(this);
		this._onPremiumConfirm = this._onPremiumConfirm.bind(this);
		this._safeGet = this._safeGet.bind(this);
		this._safeSet = this._safeSet.bind(this);
	}

	componentDidMount() {
		var storageKey = this.props.storageKey;
		var defaultHidden = !!this.props.defaultHidden;

		if (!storageKey) {
			this.setState({
				collapsed: defaultHidden,
				dismissed: false
			});
			return;
		}

		var dismissed = this._safeGet(storageKey) === '1';

		this.setState({
			dismissed: dismissed,
			collapsed: dismissed ? true : defaultHidden
		});
	}

	_safeGet(key) {
		try {
			if (!window || !window.localStorage) return null;
			return window.localStorage.getItem(key);
		} catch (e) {
			return null;
		}
	}

	_safeSet(key, val) {
		try {
			if (!window || !window.localStorage) return;
			window.localStorage.setItem(key, val);
		} catch (e) { }
	}

	_dismiss(e) {
		if (e && e.preventDefault) e.preventDefault();
		if (e && e.stopPropagation) e.stopPropagation();

		if (this.props.storageKey) {
			this._safeSet(this.props.storageKey, '1');
		}

		this.setState({ dismissed: true, collapsed: true });

		if (typeof this.props.onDismiss === 'function') {
			this.props.onDismiss();
		}
	}

	_expand(e) {
		if (e && e.preventDefault) e.preventDefault();
		if (e && e.stopPropagation) e.stopPropagation();

		// User explicitly wants it back → persist expanded
		if (this.props.storageKey) {
			this._safeSet(this.props.storageKey, '0');
		}

		this.setState({
			dismissed: false,
			collapsed: false
		});

		if (typeof this.props.onExpand === 'function') {
			this.props.onExpand();
		}
	}


	_collapse(e) {
		if (e && e.preventDefault) e.preventDefault();
		if (e && e.stopPropagation) e.stopPropagation();

		this.setState({ collapsed: true });

		if (typeof this.props.onCollapse === 'function') {
			this.props.onCollapse();
		}
	}

	openPremiumCredits(e) {
		if (e && e.preventDefault) e.preventDefault();
		if (e && e.stopPropagation) e.stopPropagation();

		if (this.premiumCreditsModal && typeof this.premiumCreditsModal.toggle === 'function') {
			this.premiumCreditsModal.toggle();
		}
	}

	_onPremiumConfirm(selectedPack, done) {
		if (typeof this.props.onPremiumConfirm === 'function') {
			this.props.onPremiumConfirm(selectedPack, done);
			return;
		}
		if (done && typeof done === 'function') done();
	}

	render() {
		if (!_hasPermission(this.props.user, 'skip-trace')) {
			return null;
		}
		var variant = this.props.variant || 'default';
		var allowDismiss = this.props.allowDismiss !== false;

		var className =
			'mp-callout-banner mp-callout-banner--' + variant +
			(this.props.className ? ' ' + this.props.className : '');

		var children = this.props.children;
		var content = (typeof children === 'function')
			? children({ openPremiumCredits: this.openPremiumCredits })
			: children;

		var collapsedLabel = this.props.collapsedLabel || 'Show Announcement';
		var collapsedPill = this.props.collapsedPill || null;

		// When collapsed, show a small stub row with a "Show" link
		if (this.state.collapsed) {
			// Allow caller to hide the stub entirely if they truly want it gone
			if (this.props.hideCollapsedStub) return null;

			return (
				<div className={className + ' mp-callout-banner--collapsed'}>
					<div className="mp-callout-banner__collapsed">
						{collapsedPill ? (
							<span className="mp-callout-banner__collapsed-pill">{collapsedPill}</span>
						) : null}


						<a
							href="javascript:void(0)"
							className="mp-callout-banner__collapsed-link link-text"
							onClick={this._expand}
						>
							<Tooltip title={collapsedLabel}><IconButton size={`small`} style={{ background: "transparent", marginTop: -2 }}>
								<HelpCircleOutlineIcon size={13} color={'#780F9E'} /></IconButton></Tooltip>{collapsedLabel}
						</a>
					</div>

					<PremiumCreditsPurchaseModal
						ref={function (ref) { this.premiumCreditsModal = ref; }.bind(this)}
						renderButton={function () { return null; }}
						onConfirm={this._onPremiumConfirm}
					/>
				</div>
			);
		}

		return (
			<div className={className}>
				<div className="mp-callout-banner__glow" />

				{allowDismiss ? (
					<a
						href="javascript:void(0)"
						className="mp-callout-banner__dismiss"
						onClick={this._dismiss}
						aria-label="Dismiss"
					>
						×
					</a>
				) : null}

				<div className="mp-callout-banner__inner">
					{content}
				</div>

				{false && allowDismiss ? (
					<div className="mp-callout-banner__footer">
						<a
							href="javascript:void(0)"
							className="mp-callout-banner__footer-link"
							onClick={this._collapse}
						>
							Hide
						</a>
					</div>
				) : null}

				<PremiumCreditsPurchaseModal
					ref={function (ref) { this.premiumCreditsModal = ref; }.bind(this)}
					renderButton={function () { return null; }}
					onConfirm={this._onPremiumConfirm}
				/>
			</div>
		);
	}
}

export default connect(state => ({
	user: state.user
}))(CalloutBanner);
